<template>
  <div class="charts-header">
    <div class="charts-header--clear" v-if="isLayoutDesktop">
      <div class="charts-header--left">
        <div class="charts-header__logo"></div>
      </div>
      <div class="charts-header--right">
        <div v-if="showDownload" class="charts-header__download" @click.prevent.stop="onDownload">
          <div class="charts-header__download-icon"></div>
        </div>
      </div>
    </div>
    <div class="charts-header--clear" v-if="false">
      <div class="charts-header--left">
        Volume <img src="@/assets/icons/markets/trade-volume.svg" />
      </div>
      <div class="charts-header--right">
        <img src="@/assets/icons/markets/price-icon.svg" /> Price
      </div>
    </div>
  </div>
</template>

<script src="./header.js"></script>
<style src="./header.scss" lang="scss"></style>
